import { ToastrService } from 'ngx-toastr';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CommonModule, DatePipe } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Correspondance } from '../../models/Correspondance';

@Component({
  selector: 'app-create-correspondance',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatIconModule,
  ],
  templateUrl: './create-correspondance.component.html',
  styleUrl: './create-correspondance.component.css',
})
export class CreateCorrespondanceComponent {
  correspondance: Correspondance = new Correspondance();
  correspondanceForm: FormGroup;
  updateStatus: boolean = false;

  @Output() createCorrespondanceEmit = new EventEmitter<Correspondance>();

  @Output() updateCorrespondanceEmit = new EventEmitter<Correspondance>();

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.correspondanceForm = this.formBuilder.group({
      isDeleted: [null, []],
      codeDivalto: ['', Validators.required],
      libelleDivalto: ['', Validators.required],
      libelleRg: ['', Validators.required],
      libelleBit: ['', Validators.required],
    });

    if (this.data) {
      this.updateStatus = true;
      this.correspondance = this.data.correspondance;
      this.correspondanceForm.setValue(this.correspondance as any);
      const control = this.correspondanceForm.get('codeDivalto');
      if (control) control.disable();
    }
  }
  public formSubmit() {
    this.correspondance = this.correspondanceForm.getRawValue();
    if (!this.updateStatus) {
      this.createCorrespondanceEmit.emit(this.correspondance);
    } else {
      this.updateCorrespondanceEmit.emit(this.correspondance);
    }
  }
}
